import React, { useCallback, useEffect, useRef, useState } from 'react';

import { AutoStories } from '@mui/icons-material';
import {
  Tooltip, 
} from "@mui/material";

import { 
  Character, 
  SubscriptionType, 
} from "@dndModels";

import ModalOrDrawer from "@components/display/ModalOrDrawer";
import CharacterSpellsAndKnowledge from "@dndComponents/character/knowledge/CharacterSpellsAndKnowledge";

interface Props {
  char: Character;
}

export default function CharacterKnowledgeButton({
  char,
}: Props) {
  const [open, setOpen] = useState(false);
  const [reloading, setReloading] = useState(false);
  const mounted = useRef(false);

  useEffect(() => { 
    mounted.current = true;

    return () => {
      mounted.current = false;
    };
  }, []);

  const recalculated = useCallback((triggered_by: SubscriptionType, from_recalc: boolean) => {
    if (triggered_by !== "Spells Recalculated" || !from_recalc) {
      // console.log("Char Knowledge");
      setReloading(true);
    }
  }, []);

  useEffect(() => {
    char.subscription_holder.subscribe("Recalculated", mounted, recalculated);
    char.subscription_holder.subscribe("Spells Recalculated", mounted, recalculated);
    char.subscription_holder.subscribe("Modal Closed", mounted, recalculated);
  }, [char, recalculated]);
  
  useEffect(() => {
    if (reloading) {
      setReloading(false);
    }
  }, [reloading, setReloading]);

  const renderExtras = () => {
    return (
      <ModalOrDrawer
        open={ open } 
        onClose={() => {
          setOpen(false);
          char.subscription_holder.modalClosed();
        }}>
        { open &&
          <CharacterSpellsAndKnowledge 
            char={char}
          />
        }
      </ModalOrDrawer>
    );
  }

  let needs_attention = false;
  const classes = char.classes.filter(o => o.spellcasting_ability !== "None");
  for (let i = 0; i < classes.length; ++i) {
    const char_class = classes[i];
    if (char_class.cantrips.length !== char_class.cantrips_max || 
      char_class.leveled_spells.length !== char_class.spells_prepared_max) {
      needs_attention = true;
      break;
    }
  }
  return (
    <>
      <Tooltip title="Manage your Spells and other Knowledge">
        <AutoStories
          className={ needs_attention ? "Flashing clickable" : "clickable" }
          onClick={() => {
            setOpen(true);
          }}
        />
      </Tooltip>
      { renderExtras() }
    </>
  ); 
}

